const OUTPATIENT_DEPARTMENT_TYPES = ['O', 'H', 'E'];

function filterDepartmentOptions(departments, source) {
  const options = Array.isArray(departments) ? departments : [];
  if (source !== '门诊' && source !== '住院') {
    return options.slice();
  }

  const allowedTypes = source === '门诊' ? OUTPATIENT_DEPARTMENT_TYPES : ['I'];
  return options.filter(option => {
    if (option && option.value == null) {
      return true;
    }
    const type = option && option.type ? String(option.type).toUpperCase() : '';
    return allowedTypes.includes(type);
  });
}

function emptyDepartmentSelection(selection) {
  return Array.isArray(selection) ? [] : null;
}

module.exports = {
  filterDepartmentOptions,
  emptyDepartmentSelection
};
